// extracted by mini-css-extract-plugin
export default {"travelocity_home_page":"Home_travelocity_home_page__bVCYf","Home_make_some_space":"Home_Home_make_some_space__p8w6t"};